export const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  fontSize: '18px',
  background: 'white',
  padding: '0',
  cursor: 'context-menu',
  borderBottom: '1px solid gray',
  textWrap: 'auto',
  wordWrap: 'break-word',
};

export const style = {
  display: 'flex',
  textAlign: 'left',
  cursor: 'context-menu',
  borderRight: 'none',
};
